import React, { useState, useEffect } from 'react';
import { Bell, Settings, Cloud, MapPin, Menu } from 'lucide-react';
import './Header.css';

const Header = ({ alertCount, onMenuToggle, onNavigate }) => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (d) =>
    d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });

  const formatDate = (d) =>
    d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

  return (
    <header className="header">
      <div className="header-left">
        <div className="logo-mark">
          <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="19" stroke="#3b82f6" strokeWidth="2" fill="#0f2035"/>
            <path d="M20 8 L28 14 L28 22 L20 32 L12 22 L12 14 Z" fill="#3b82f6" opacity="0.3"/>
            <path d="M20 8 L28 14 L28 22 L20 32 L12 22 L12 14 Z" stroke="#3b82f6" strokeWidth="1.5" fill="none"/>
            <text x="20" y="23" textAnchor="middle" fill="#e2e8f0" fontSize="9" fontFamily="Rajdhani" fontWeight="700">AP</text>
          </svg>
        </div>
        <div className="logo-text">
          <span className="logo-title">Smart Baton</span>
          <span className="logo-sub">Vijayawada City Command Centre</span>
        </div>
      </div>

      <div className="header-center">
        <div className="live-badge">
          <span className="live-dot"></span>
          <span>LIVE</span>
        </div>
        <div className="weather-badge">
          <Cloud size={14} />
          <span>32°C</span>
        </div>
        <div className="datetime">
          <span className="date">{formatDate(time)}</span>
          <span className="separator">|</span>
          <span className="time">{formatTime(time)}</span>
        </div>
      </div>

      <div className="header-right">
        <div className="location-badge">
          <MapPin size={13} />
          <span>Vijayawada</span>
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 4l3 3 3-3" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round"/></svg>
        </div>

        {/* Notification button → navigates to Alerts */}
        <button
          className="icon-btn notification-btn"
          onClick={() => onNavigate && onNavigate('alerts')}
          title="Alerts"
        >
          <Bell size={18} />
          {alertCount > 0 && <span className="notif-badge">{alertCount}</span>}
        </button>

        {/* Settings button → navigates to Settings */}
        <button
          className="icon-btn"
          onClick={() => onNavigate && onNavigate('settings')}
          title="Settings"
        >
          <Settings size={18} />
        </button>

        <button className="icon-btn menu-btn" onClick={onMenuToggle}>
          <Menu size={18} />
        </button>
      </div>
    </header>
  );
};

export default Header;